/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import store from '../store'
import DashboardLayout from '@/layout/dashboard/DashboardLayout.vue'
// GeneralViews
import NotFound from '@/pages/NotFoundPage.vue'
import ChooseCity from '@/components/ChooseCity'
import Products from '@/pages/Products.vue'
import Users from '@/pages/Users.vue'

// Admin pages
// const Dashboard = () => import(/* webpackChunkName: "dashboard" */"@/pages/Dashboard.vue");
const Dashboard = () => import(/* webpackChunkName: "dashboard" */'@/components/DashViews/Dashboard.vue')
const Login = () => import(/* webpackChunkName: "dashboard" */'@/components/LoginForm.vue')
const Profile = () => import(/* webpackChunkName: "common" */ '@/pages/Profile.vue')
const Notifications = () => import(/* webpackChunkName: "common" */'@/pages/Notifications.vue')
// const Icons = () => import(/* webpackChunkName: "common" */ "@/pages/Icons.vue");
const Categories = () => import(/* webpackChunkName: "common" */ '@/pages/Categories.vue')
const Topics = () => import(/* webpackChunkName: "common" */ '@/pages/Topics.vue')
const Tags = () => import(/* webpackChunkName: "common" */ '@/pages/Tags.vue')
const Ads = () => import(/* webpackChunkName: "common" */ '@/pages/Ads.vue')
const Links = () => import(/* webpackChunkName: "common" */ '@/pages/Links.vue')
const Logs = () => import(/* webpackChunkName: "common" */ '@/pages/ActivityLogs.vue')
const Spams = () => import(/* webpackChunkName: "common" */ '@/pages/Spams.vue')
const DashboardContent = () => import(/* webpackChunkName: "common" */ '@/layout/dashboard/Content.vue')
export default [
  {
    path: '*',
    meta: {
      name: 'requiresAuth',
      requiresAuth: true
    },
    redirect: {
      path: '/users'
    }
  },
  {
    path: '/choose-city',
    meta: {
      name: 'requiresAuth',
      requiresAuth: true
    },
    component: ChooseCity
  },
  // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: '/',
    meta: {
      name: '',
      requiresAuth: false
    },
    component: DashboardContent,
    // redirect if already signed in
    beforeEnter: (_to, _from, next) => {
      if (store.getters.authorized) {
        next('/users')
      } else {
        next()
      }
    },
    children: [
      {
        path: '',
        component: Login
      }
    ]
  },
  // add any extra routes that you want rendered in the dashboard as a child below. Change toolbar names here
  {
    path: '/',
    meta: {
      name: 'Dashboard View',
      requiresAuth: true
    },
    component: DashboardLayout,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'profile',
        meta: {
          name: 'Profile',
          requiresAuth: true
        },
        component: Profile
      },
      {
        path: 'users',
        meta: {
          name: 'Users',
          requiresAuth: true
        },
        component: Users
      },
      {
        path: 'products',
        meta: {
          name: 'Products',
          requiresAuth: true
        },
        component: Products
      },
      {
        path: 'categories',
        meta: {
          name: 'Categories',
          requiresAuth: true
        },
        component: Categories
      },
      {
        path: 'topics',
        meta: {
          name: 'Topics',
          requiresAuth: true
        },
        component: Topics
      },
      {
        path: 'tags',
        meta: {
          name: 'Tags',
          requiresAuth: true
        },
        component: Tags
      },
      {
        path: 'ads',
        meta: {
          name: 'Ads',
          requiresAuth: true
        },
        component: Ads
      },
      {
        path: 'links',
        meta: {
          name: 'Links',
          requiresAuth: true
        },
        component: Links
      },
      {
        path: 'logs',
        meta: {
          name: 'Logs',
          requiresAuth: true
        },
        component: Logs
      },
      {
        path: 'spams',
        meta: {
          name: 'Spams',
          requiresAuth: true
        },
        component: Spams
      },
      {
        path: 'notifications',
        meta: {
          name: 'Notifications',
          requiresAuth: true
        },
        component: Notifications
      }
    ]
  },
  { path: '*', component: NotFound }
]
